import "./globals.css";
import type { Metadata } from "next";

export const metadata: Metadata = {
  title: "Bangkok Dress Inventory",
  description: "Inventory and order management for dress reselling business",
};

export default function RootLayout({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  return (
    <html lang="en">
      <body suppressHydrationWarning>{children}</body>
    </html>
  );
}